import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      el: this.el
    };

    this.scroll();
  }

  scroll() {
    const shouldScrollToContent = new window.URLSearchParams(
      document.location.search
    ).get('scrolltocontent');

    if (shouldScrollToContent === null) return;

    const targetTopPosition =
      this.dom.el.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: targetTopPosition,
      behavior: 'smooth'
    });
  }
}

export default Module;
